export function allocateFreeModifiersCharges(group) {
    const freeModifiers = Number(group?.freeModifiers) || 0;

    const selections =
        group?.min === 1 && group?.max === 1
            ? [group?.selectedOption].filter(Boolean)
            : group?.selectedOptions || [];

    const qtyById = new Map();

    for (const selection of selections) {
        const id = selection?.id;
        const qty = selection?.quantity ?? 1;

        if (!id || qty <= 0) {
            continue;
        }

        qtyById.set(id, (qtyById.get(id) || 0) + qty);
    }

    if (freeModifiers <= 0) {
        return qtyById;
    }

    const priceById = new Map(
        (group?.products || []).map(p => [p.id, Number(p.price) || 0])
    );

    const items = Array.from(qtyById.entries()).map(([id, qty]) => ({
        id,
        qty,
        price: priceById.get(id) ?? 0
    }));

    items.sort((a, b) => {
        if (b.price !== a.price) {
            return b.price - a.price;
        }

        return String(a.id).localeCompare(String(b.id));
    });

    const paidById = new Map();
    let freebies = freeModifiers;

    for (const { id, qty } of items) {
        const free = Math.min(freebies, qty);
        const charged = qty - free;

        paidById.set(id, charged);

        freebies -= free;
    }

    return paidById;
}

export function getPaidOptionIds(group) {
    const paidById = allocateFreeModifiersCharges(group);

    const paidIds = [];

    for (const [id, qty] of paidById.entries()) {
        if (qty > 0) {
            paidIds.push(id);
        }
    }

    return paidIds;
}
